import React, { useEffect } from "react";
import { Grid, Card, Typography, Box, Button, FormControl, Stack, MenuItem, InputLabel, Select } from "@mui/material";
import { localizedName } from "../../helper/LangHelper";
import { timeToDateStr } from "../../helper/StringHelper";
import { useNavigate } from "react-router-dom";
// import { MemberApi } from "../api/MemberApi";
// import { useSelector, useDispatch } from "react-redux";
// import { memberID, updateAuthState } from "../reducers/userSlice";
import { dateValueToTimeStr } from "../../helper/StringHelper";
import CommonDataSelection from "../common/CommonDataSelection/CommonDataSelection";
import CommonDatePicker from "../common/CommonDatePicker/CommonDatePicker";
import CommonDateRangePicker from "../common/CommonDateRangePicker/CommonDateRangePicker";
import { set } from "date-fns";
// import { dateValueToYYYYMMDD } from "../../helper/TimeHelper";
import { dateValueToYYYYMMDD } from "../../helper/TimeHelper";

function getDefaultEventID(eventList) {
    if (eventList.length > 0) {
        return eventList[0].id;
    }

    return 0;
}

function getEventFromList(eventList, eventID) {
    for (let event of eventList) {
        if (event.id === eventID) {
            return event;
        }
    }

    return null;
}

export default function EventLeaderboardQueryForm({ eventList, onQuery }) {
    const [eventID, setEventID] = React.useState(-1); // getDefaultEventID(eventList));
    const [event, setEvent] = React.useState(null);
    const [selectedDate, setSelectedDate] = React.useState(null);

    const [selectedDateRange, setSelectedDateRange] = React.useState(null);

    const [timeslotList, setTimeslotList] = React.useState([]);
    const [timeslotID, setTimeslotID] = React.useState(0);

    const [skillList, setSkillList] = React.useState([]);
    const [skillID, setSkillID] = React.useState(0);

    useEffect(() => {
        console.debug("Event Object is changed: ", event);
        if (event != null) {
            setTimeslotList(event.timeslotList);
            setSkillList(event.leaderboardSetting);
        }
    }, [event]);

    useEffect(() => {
        setTimeslotID(0);
    }, [timeslotList]);

    useEffect(() => {
        setSkillID(0);
    }, [skillList]);

    useEffect(() => {
        const initialEventID = getDefaultEventID(eventList);
        setEventID(initialEventID);
        var event = getEventFromList(eventList, initialEventID);
        setEvent(event);

    }, []);

    const onEventChanged = (evt) => {
        setEventID(evt.target.value);

        var event = getEventFromList(eventList, evt.target.value);
        setEvent(event);

    };

    const onTimeslotChanged = (evt) => {
        setTimeslotID(evt.target.value);
    };

    const onQueryClicked = () => {
        if (onQuery != null) {
            onQuery({ eventID, timeslotID, skillID, selectedDate, selectedDateRange });
        }
    }

    // skill control
    const onDateChanged = (date) => {
        setSelectedDate(date);
    }

    const onDateRangeChanged = (dateRange) => {
        console.debug("onDateRangeChanged: ", dateRange);

        if (dateRange == null || dateRange.length < 2) {
            // setSelectedDateRange(null);
            // ken: invalid date range, do not set
            return;
        }

        let dateStrRange = [
            dateValueToYYYYMMDD(dateRange[0]),
            dateValueToYYYYMMDD(dateRange[1])
        ];

        setSelectedDateRange(dateStrRange);
    }

    const onSkillChanged = (evt) => {
        setSkillID(evt.target.value);
    };

    const getMinDate = () => {
        if (event != null) {
            return event.start_at;
        }
    }

    const getMaxDate = () => {
        if (event != null) {
            return event.end_at;
        }
    }

    const minDate = new Date("2023-05-05");
    const maxDate = new Date("2030-12-31");


    return (<Card>
        <Box sx={{ padding: 2 }}>
            {/* <Typography variant="h5">Event Leaderboard</Typography> */}
            {/* {eventSelection} */}
            <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                    <CommonDateRangePicker
                        minDate={minDate}
                        maxDate={maxDate}
                        onChange={onDateRangeChanged}
                        defaultRange="1day"
                    ></CommonDateRangePicker>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <CommonDataSelection
                        key="event"
                        label="活動"
                        value={eventID}
                        dataList={eventList}
                        captionFn={(item) => item.name_zh}
                        onChange={onEventChanged}
                    />
                </Grid>

                {/* <Grid item xs={12} sm={6}>
                    <CommonDatePicker dateValue={selectedDate}
                        minDate={getMinDate()}
                        maxDate={getMaxDate()}
                        onChange={onDateChanged}
                    ></CommonDatePicker>
                </Grid> */}
                {/* <Grid item xs={12} sm={6}>
                    <CommonDataSelection
                        key="timeslot"
                        label="時段"
                        value={timeslotID}
                        allOption={true}
                        dataList={timeslotList}
                        captionFn={(item) => item.timeslot_caption}
                        onChange={onTimeslotChanged}
                    />
                </Grid> */}
                <Grid item xs={12} sm={6}>
                    <Button variant="contained" onClick={onQueryClicked}>查詢</Button>
                </Grid>
                {/* <Grid item xs={12} sm={6}>
                    <Stack direction="row" spacing={1}>

                        
                        <CommonDataSelection
                            key="skill"
                            label="技能"
                            value={skillID}
                            allOption={true}
                            dataList={skillList}
                            captionFn={(item) => item.skill_name}
                            onChange={onSkillChanged}
                        />



                        <Button variant="contained" onClick={onQueryClicked}>查詢</Button>
                    </Stack>
                </Grid> */}
            </Grid>




        </Box>
        <pre>
            {/* DEBUG: eventID={eventID} timeslot: {timeslotID} skill: {skillID} selectedDate: {dateValueToTimeStr(selectedDate)} 
            <br/>
            {JSON.stringify(eventList, null, 2)} */}
        </pre>
    </Card>);
}